<template>
  <danger-alert v-if = "errors?.document?.[0]" :message="errors?.document?.[0]" />
  <viewer-form :require-back="true" @back="toList">
    <div class="row">
      <textarea-browse-item label="資料名" :value="document_name" />
      <textarea-browse-item label="概要" :value="outline" />
    </div>
    <div class="position-relative row">
      <file-name-item label="ファイル名" :file_name="file_name" />
      <div class="position-absolute top-0 start-50 w-50">
        <download-button @click="toExport(uuid)" />
      </div>
    </div>
  </viewer-form>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import AddonLoadPageEvent from '@/mixin/AddonLoadPageEvent';
import TextareaBrowseItem from "@/views/molecules/browseItems/TextareaBrowseItem";
import ViewerForm from "@/views/templates/forms/ViewerForm";
import DownloadButton from '@/views/molecules/buttons/DownloadButton';
import DangerAlert from '@/views/atoms/alerts/DangerAlert';
import FileNameItem from "@/views/molecules/browseItems/FileNameItem";

export default {
  name: 'PublicDocumentViewer',
  components: {
    TextareaBrowseItem,
    ViewerForm,
    DownloadButton,
    DangerAlert,
    FileNameItem,
  },
  mixins: [AddonLoadPageEvent],
  inject: [
    '$constant'
  ],
  beforeRouteLeave() {
    this.resetData();
  },
  computed: {
    ...mapState('public_document_form', {
      document_name: state => state.data.document_name,
      outline: state => state.data.outline,
      file_name: state => state.data.file_name,
      uuid: state => state.data.uuid,
      errors: state => state.errors,
    }),
    ...mapState('public_document_index', {
      management_company_id: state => state.management_company_id,
    }),
    ...mapState('account', {
      is_guest: state => state.is_guest,
    }),
  },
  methods: {
    ...mapMutations('public_document_form', [
      'resetData',
    ]),
    loadPage() {
      return this.$store.dispatch('public_document_form/load', { 'id': this.$route.params.id }).then(() => {
        this.$root.showFlashMessage();
      }).catch(() => this.$root.failApi());
    },
    toList() {
      this.$router.push({
        name: this.is_guest ? 'GuestPublicDocumentList' : 'PublicDocumentList',
        params: { management_company_id: this.management_company_id ? this.management_company_id : sessionStorage.getItem('management_company_id') },
      });
    },
    async toExport(uuid) {
      await this.$store.dispatch('public_document_form/export', { uuid: uuid }).then(() => {
        this.$root.showFlashMessage();
      }).catch((reason) => this.$root.failApi(reason));
    }
  }
}
</script>
